/**
 * @generated SignedSource<<2309f7554f7c3a86314e4123cacd6391>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModuleCarousel_viewer$data = {
  readonly onSaleItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemTilesCarouselModule_items">;
      } | null;
    } | null> | null;
    readonly totalResults: number | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemTilesCarouselModule_viewer">;
  readonly " $fragmentType": "HpSharedFeaturedModuleCarousel_viewer";
};
export type HpSharedFeaturedModuleCarousel_viewer$key = {
  readonly " $data"?: HpSharedFeaturedModuleCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleCarousel_viewer">;
};

import HpSharedFeaturedModuleCarouselPaginationQuery_graphql from './HpSharedFeaturedModuleCarouselPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "onSaleItems"
],
v1 = {
  "kind": "Variable",
  "name": "fetchFavorites",
  "variableName": "hasUserId"
},
v2 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 6,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": HpSharedFeaturedModuleCarouselPaginationQuery_graphql
    }
  },
  "name": "HpSharedFeaturedModuleCarousel_viewer",
  "selections": [
    {
      "alias": "onSaleItems",
      "args": null,
      "concreteType": "ItemSearchTreandingConnection",
      "kind": "LinkedField",
      "name": "__HpSharedFeaturedModuleCarousel_onSaleItems_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemSearchTreandingEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": [
                    (v1/*: any*/),
                    {
                      "kind": "Variable",
                      "name": "isTrade",
                      "variableName": "isTrade"
                    },
                    {
                      "kind": "Variable",
                      "name": "priceBookName",
                      "variableName": "priceBookName"
                    },
                    (v2/*: any*/)
                  ],
                  "kind": "FragmentSpread",
                  "name": "HpSharedItemTilesCarouselModule_items"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        (v1/*: any*/),
        (v2/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "HpSharedItemTilesCarouselModule_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "f62a4d0b59e91086cf968cdcf352f9c5";

export default node;
